import { render, staticRenderFns } from "./zjthjlList.vue?vue&type=template&id=844b04ba"
import script from "./zjthjlList.vue?vue&type=script&lang=js"
export * from "./zjthjlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports